export function sendOutgrowEvent(event: OutgrowEvent) {
  window.parent.postMessage(event, { targetOrigin: "*" });
}

export type OutgrowEvent =
  | { type: "navigate"; payload: { route: string } }
  | { type: "publishBot" }
  | { type: "changeBotName"; payload: { name: string } }
  | { type: "changeBotUrl"; payload: { url: string } }
  | { type: "syncUpdatedAt" };
